import {
  FormControlLabel,
  MenuItem,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import { useNode } from '@craftjs/core';

const FaqsSettings = () => {
  const {
    actions: { setProp },
    propValue: { limit, enableLimit },
  } = useNode((node) => ({
    propValue: node.data.props,
  }));

  const limitPoints = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <Stack spacing={2} direction={'row'} justifyContent={'space-around'}>
      <TextField
        fullWidth
        select
        size="small"
        name="limit"
        label="Límite"
        value={limit}
        defaultValue={limit ?? 5}
        onChange={(e) =>
          setProp((props: Props) => {
            props.limit = e.target.value;
            return props;
          })
        }
      >
        <MenuItem value={'all'}>Todas</MenuItem>
        {limitPoints.map((limit, index) => (
          <MenuItem key={`${limit}-${index}`} value={limit}>
            {limit}
          </MenuItem>
        ))}
      </TextField>
      <FormControlLabel
        control={
          <Switch
            defaultValue={enableLimit}
            value={enableLimit}
            onChange={(e) =>
              setProp((props: Props) => {
                props.enableLimit = e.target.checked;
                return props;
              })
            }
          />
        }
        label="Habilitar"
      />
    </Stack>
  );
};

export default FaqsSettings;
